import React from 'react';
import ContentData from '../ContentData';
import cn from './style.module.scss';
export default function StoryContent(props: any) {
  const { t } = props;
  return (
    <div className={cn.themeContent}>
      <div
        className={cn.shapeDesktop}
        data-key={props.shapeDesktopImg.name}
        style={{
          backgroundImage: `url(${props.shapeDesktopImg.url})`,
        }}
      >
        <ContentData t={t} />
      </div>
      <div
        className={cn.shapeMobile}
        data-key={props.shapeMobileImg.name}
        style={{
          backgroundImage: `url(${props.shapeMobileImg.url})`,
        }}
      >
        <ContentData t={t} />
      </div>
    </div>
  );
}
